import { React, useEffect, useReducer, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form, Input } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, HistoryOutlined, PlusOutlined, EditOutlined, DeleteOutlined} from '@ant-design/icons';
import {  ADD_BATCH, ADD_BATCH_ERROR, ADD_BATCH_SUCCESS, BATCH_DETAILS, BATCH_DETAILS_ERROR, BATCH_DETAILS_SUCCESS, DELETE_BATCH, DELETE_BATCH_ERROR, DELETE_BATCH_SUCCESS, EDIT_BATCH, EDIT_BATCH_ERROR, EDIT_BATCH_SUCCESS, SHIFT_QUESTION_BATCH_LIST, SHIFT_QUESTION_BATCH_LIST_ERROR, SHIFT_QUESTION_BATCH_LIST_SUCCESS} from './constants';
import axios from 'axios';
import modelReducer from './reducer';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';

const { Title } = Typography;



export default function ShiftManagement() {


	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = { retrain_historydata:[], batch : [], details: null, loading: false, error: false, modelDeploymentInfo:[]};
	const [data, dispatch] = useReducer(modelReducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteBatchModal, setShowDeleteBatchModal] = useState(false);
	useAuth();
	
	const navigate = useNavigate();
	const [form] = Form.useForm();	
	
	

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);


	const columns = [

		
		{
			title: `${langdata && langdata.Name ? langdata.Name:'Name'}`,
			dataIndex: 'name',
			key: 'name',
			render : (_,text) =>(
				<>
					
					<a onClick={()=> navigate(('/add-shift-question'),{state : {id:text.id}})}>
						{text.name} 
					</a>
		
				</>
			)
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: () => (
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={showEditDrawer}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteAssetsModal}><DeleteOutlined /></a>
					</Space>
				</>
			)
		}
	
	];

	

	
	useEffect(() => {
		if(featuresModule.shiftManagementEnabled == false) {
			navigate('/dashboard');
		}
		if(!authtoken){
			navigate('/');
		}
	
	},[authtoken]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4019);

	}, []);
	
	useEffect(() => {
		loadShiftBatch();
	}, []);


	const loadShiftBatch = () => {

		dispatch({ type : SHIFT_QUESTION_BATCH_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/shiftquestionbatch?pipelineId=${pipelineId}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
    
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : SHIFT_QUESTION_BATCH_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : SHIFT_QUESTION_BATCH_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : SHIFT_QUESTION_BATCH_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};
	
	
	



	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.ThisModuleIsUsedToCategorizeAndGroupQuestionsIntoBatchesAcrossDifferentQuestionGroupSections ? langdata.ThisModuleIsUsedToCategorizeAndGroupQuestionsIntoBatchesAcrossDifferentQuestionGroupSections :'This module is used to categorize and group questions into batches across different question group sections.'}</p>
		</Card>
	);


	const showAddDrawer = () => {

		setOpenAddDrawer(true);
	};

	const onCloseAddDrawer = () => {
		form.resetFields();
		addBatch.resetForm();
		setOpenAddDrawer(false);
	};

	const showEditDrawer = () => {
		
		setOpenEditDrawer(true);
		
	};

	const openDeleteAssetsModal = () => {
		setShowDeleteBatchModal(true);
	};

	const addBatch = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
	
		},
		onSubmit: (values) => {
	
					
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}
	
			dispatch({type:ADD_BATCH});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/shiftquestionbatch`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					pipelineId : parseInt(pipelineId)
				}
			};
	
			axios
				.request(config)	
				.then((response) => {
						
	
					if (response.status === 200 || response.status === 201) {
	
		
						dispatch( { type: ADD_BATCH_SUCCESS, payload: response.data.data });
	
						Modal.success({ title: `${langdata && langdata.AddBatchSuccessfull ? langdata.AddBatchSuccessfull :'Batch Added Successfully'}` });
						loadShiftBatch();
						form.resetFields();
						addBatch.resetForm();
						setOpenAddDrawer(false);
	
						
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: ADD_BATCH_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});


	const editBatch = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
			
		},
		onSubmit: (values) => {
	
		
			dispatch({type:EDIT_BATCH});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/shiftquestionbatch/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_BATCH_SUCCESS});
						Modal.success({ title: `${langdata && langdata.BatchUpdatedSuccessfully ? langdata.BatchUpdatedSuccessfully :'Batch Updated Successfully'}` });
						editBatch.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						loadShiftBatch();
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: EDIT_BATCH_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadBatchDetials = ((record) => {
		
		dispatch( { type: BATCH_DETAILS });
			
		if (!record) {
			dispatch({ type: BATCH_DETAILS_ERROR });
		} else {
			dispatch({ type: BATCH_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		form.resetFields();
		editBatch.resetForm();
		setOpenEditDrawer(false);

	};
	const closeDeleteBatchModal = () => {
		setShowDeleteBatchModal(false);
	};

	const deleteBatch = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_BATCH });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/shiftquestionbatch/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_BATCH_SUCCESS, payload: response});
					setShowDeleteBatchModal(false);        
					loadShiftBatch();
				} else {
					dispatch({type:DELETE_BATCH_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_BATCH_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	


	return (
		<>
			<Content>
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >

					<Col span={8}>
						<Row>

							<Space>
								<HistoryOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.ShiftManagement ? langdata.ShiftManagement:'Shift Management'}</Title>
						</Row>
					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
		
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.ShiftManagement ? langdata.ShiftManagement:'ShiftManagement'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.batch?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.batch} 
								onChange = { loadShiftBatch }
								
								
								onRow={(record) => {
									return {
										onClick: () => { 
											loadBatchDetials(record);
										}
									};
								}} />
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				<Modal
					title={ langdata&&langdata.AddBatch ? langdata.AddBatch : 'Add Batch' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addBatch.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addBatch.handleSubmit} form={form} >
									
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata&&langdata.Name?langdata.Name:'Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please Enter Name' }]} >
									<Input name="name" onChange={addBatch.handleChange} placeholder={langdata&&langdata.PleaseEnterName?langdata.PleaseEnterName:'Please Enter Name'} />
								</Form.Item>
							</Col>
						</Row>														
					</Form>
				</Modal>


				<Modal
					title={langdata && langdata.EditBatchDetails ? langdata.EditBatchDetails:'Edit Batch Details'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editBatch.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editBatch.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editBatch.handleSubmit} layout="vertical"
						form={form} 
						// onValuesChange={handleUpdateFormValuesChange}
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<Input name="name" value={editBatch.values.name} onChange={editBatch.handleChange} defaultValue={editBatch.values.name}   />
								</Form.Item>
							</Col>
						</Row>
						
				
									
					</Form>
				</Modal>



				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteBatchModal} onOk={deleteBatch} onCancel={closeDeleteBatchModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisBatch ? langdata.AreYouSureYouWantToDeleteThisBatch : 'Are you sure you want to delete this batch' }</Col>
					</Row>
				</Modal>
											
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}